import { UploadDetailsModal } from './upload-details-modal';

export { UploadDetailsModal };
